import { render, staticRenderFns } from "./PhotoGallery.vue?vue&type=template&id=67c814e9&scoped=true&"
import script from "./PhotoGallery.vue?vue&type=script&lang=js&"
export * from "./PhotoGallery.vue?vue&type=script&lang=js&"
import style0 from "./PhotoGallery.vue?vue&type=style&index=0&id=67c814e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c814e9",
  null
  
)

export default component.exports